import getESTHour from './getESTHour';

const weekdays = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
];

/**
 * Indicates if the current EST hour is inside the schedule
 *
 * @param {Object} schedule Hour ranges by day
 * @returns {Boolean} Indicates if the current EST hour is in the range.
 */
function isOnSchedule(schedule) {
  const today = new Date();
  const hour = getESTHour(today);
  const dayConfig = schedule[weekdays[today.getDay()]];

  return hour >= dayConfig.from && hour < dayConfig.to;
}

export default isOnSchedule;
